import React from 'react';
import CheckBox from '../basic/CheckBox';
import './Criterion.css';

const criterion = (props) => {
  let itemClass = "criterion padding-top-bottom-sm padding-left-right-md border-bottom";
  if (props.isFocused) {
    itemClass += " criterion-focused"
  }

  return (
    <div
      onClick={props.clicked}
      onMouseEnter={props.mouseEntered}
      className={itemClass}>
      <span>{props.label}</span>
      <CheckBox selected={props.isSelected}></CheckBox>
    </div>
  )
}

export default criterion;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/list/Criterion.js